import React from "react";


const Tooltip = ({ id, value, color }) => (
    <div style={{
        padding: '12px 16px',
        background: '#131722',
        color: color,
        fontFamily: "var(--font-title)",
        borderRadius: '4px',
        border: `1px solid ${color}`
    }}>
        <strong style={{color: '#fff'}}>{id}: {value}</strong><br/>
        <div style={{
            width: '100%',
            height: '10px',
            backgroundColor: color,
            borderRadius: '2px'
        }} />
    </div>
);

export default Tooltip;